module.exports = __webpack_public_path__ + "static/Timberland-scroll-1d12e71aeebddcb1b2c8e6e7e973c2e2.svg";